import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";

import generateGuid from "../../util/guid";
import Tooltip from "../common/Tooltip";
import * as types from "../../constants/ComponentConstants";
import ValidationMessage from "../common/ValidationMessage";

const TextInput = (props) => {
	const hasInputMask = !!props.inputmask;
	const hasValue = !!props.value || hasInputMask;
	const hasValidationMessage = !!props.validationMessage;
	const validationMessageType = props.validationMessageType;
	const tooltiptype = props.tooltipType || types.TOOLTIP_INFO;
	const value = props.value ? props.value : "";
	const sizeClassName = props.size ? "o-col-" + props.size : "o-col-12";
	const label = props.label + (props.optional ? " (Optioneel)" : "");
	const info = props.tooltip ? <Tooltip isInput text={props.tooltip} tooltipType={tooltiptype} /> : null;
	const validation = (hasValidationMessage) ? <ValidationMessage message={props.validationMessage} type={validationMessageType} /> : null;
	const maxLength = props.maxLength ? props.maxLength : "";
	const disabled = props.disabled || props.readOnly;
	const id = props.id ? props.id : generateGuid();
	const style = props.style;
	const surroundingStyle = props.surroundingStyle;

	const inputClassName = classnames({
		"c-input__field": true
	});

	const labelClassName = classnames({
		"c-input__label": true,
		"has-value": hasValue
	});

	const containerClassName = classnames({
		"c-input": true,
		"has-value": hasValue,
		"error": hasValidationMessage,
		"warning": hasValidationMessage && (validationMessageType === types.ValidationMessageTypes.WARNING),
		"disabled": disabled
	});

	function handleChange(event) {

		if(!hasInputMask){
			props.onChange(event);
			return;
		}

		var containsPrimaryInputMask = event.target.value.indexOf(props.inputmask) !== -1 || event.target.value.indexOf(props.inputmask.replace("http", "https")) !== -1 || event.target.value.indexOf(props.inputmask.replace("https", "http")) !== -1;
		if(containsPrimaryInputMask){
			props.onChange(event);
			return;
		}

		if (!containsPrimaryInputMask && Array.isArray(props.inputmaskLegacy) && props.inputmaskLegacy.length) {
		for (const legacy  of props.inputmaskLegacy) 
			{
				if (!legacy) continue;

				const legacyHttp = legacy.replace("https", "http");
				const legacyHttps = legacy.replace("http", "https");

				const hasLegacy =
				event.target.value.indexOf(legacy) !== -1 ||
				event.target.value.indexOf(legacyHttps) !== -1 ||
				event.target.value.indexOf(legacyHttp) !== -1;

				if (hasLegacy) {
					if (event.target.value.indexOf(legacy) !== -1) event.target.value = event.target.value.replace(legacy, props.inputmask);
					else if (event.target.value.indexOf(legacyHttps) !== -1) event.target.value = event.target.value.replace(legacyHttps, props.inputmask);
					else if (event.target.value.indexOf(legacyHttp) !== -1) event.target.value = event.target.value.replace(legacyHttp, props.inputmask);

					props.onChange(event);
					return;
				}
			}
		}
		
		event.target.value = props.inputmask + event.target.value;
		props.onChange(event);
	}

	return (
		<div className={sizeClassName}>
			<div className={containerClassName} style={surroundingStyle}>
				<input
					id={id}
					style={style}
					value={value}
					disabled={disabled}
					onChange={handleChange}
					className={inputClassName}
					maxLength={maxLength}
					name={props.name} />
				{props.label ?
					<label
						className={labelClassName}
						htmlFor={id}>
						{label}
					</label> : null}
				{info}
			</div>
			{validation}
		</div>
	);
};

TextInput.defaultProps = {
	validationMessageType: "ERROR"
};

TextInput.propTypes = {
	name: PropTypes.string.isRequired,
	id: PropTypes.string,
	label: PropTypes.string.isRequired,
	value: PropTypes.string,
	onChange: PropTypes.func.isRequired,
	maxLength: PropTypes.number,
	tooltip: PropTypes.string,
	tooltipType: PropTypes.string,
	validationMessage: PropTypes.string,
	validationMessageType: PropTypes.string,
	disabled: PropTypes.bool,
	readOnly: PropTypes.bool,
	size: PropTypes.number,
	optional: PropTypes.bool,
	style: PropTypes.object,
	surroundingStyle: PropTypes.object,
	inputmask: PropTypes.string,
	inputmaskLegacy: PropTypes.array
};

export default TextInput;
